module.exports = __webpack_public_path__ + "static/hero-companies-bg-4c3a0b7e99f720e9d757aa1cb3db294c.png";